import React from "react";
import { Result } from "antd";
import "antd/dist/reset.css"; // Import Ant Design styles

const NotFoundMessage = () => {
  return (
    <>
      {/* <h1 className="main-heading">
        PSG Hospitals Students Fitness Registration
      </h1> */}
      <Result
        status="404"
        title="No Students Found"
        subTitle="There are no students available at the moment."
        style={{ textAlign: "center", marginTop: "50px" }}
      />
    </>
  );
};

export default NotFoundMessage;
